module.exports = __webpack_public_path__ + "img/footprint.2a61495d.png";